import React, { useEffect } from 'react';
import M from 'materialize-css';

function CustomCheckbox({ text = '', value, setValue }) {
  useEffect(() => {
    M.AutoInit();
  }, []);

  return (
    <div className="col s2">
      <div className="col s2 center">
        <label>{text}</label>
        <div className="switch">
          <label>
            <input type="checkbox" checked={value} value={value} onChange={() => setValue(!value)} />
            <span className="lever" />
          </label>
        </div>
      </div>
    </div>
  );
}

export default CustomCheckbox;
